import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { FactoryRouteWeighReport } from './Pages';

export const FactoryRouteWeighReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={FactoryRouteWeighReport} />
    </Fragment>
)